module.exports = __webpack_public_path__ + "img/1.c805c749.jpg";